import { render, staticRenderFns } from "./hexiaoXq.vue?vue&type=template&id=45d4a0ee&scoped=true&"
import script from "./hexiaoXq.vue?vue&type=script&lang=js&"
export * from "./hexiaoXq.vue?vue&type=script&lang=js&"
import style0 from "./hexiaoXq.vue?vue&type=style&index=0&id=45d4a0ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4a0ee",
  null
  
)

export default component.exports